import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatCheckboxModule,
  MatFormFieldModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatButtonModule,
  MatInputModule
} from '@angular/material';
import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { AddressModule } from '../profile/address/address.module';
import { CollectionSettingsFormComponent } from './collection-settings/collection-settings-form/collection-settings-form.component';
import { CollectionSettingsComponent } from './collection-settings/collection-settings.component';

@NgModule({
  declarations: [
    CollectionSettingsComponent,
    CollectionSettingsFormComponent,
  ],
  entryComponents: [
    CollectionSettingsComponent,
    CollectionSettingsFormComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    AddressModule,
    ReactiveFormsModule,
  ]
})
export class CollectionsModule { }

try {
  angular.module('mandaeApp')
    .directive('appProfilePickup', downgradeComponent({ component: CollectionSettingsComponent }));
} catch (e) {}
